import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateRole, IUpdateRoleRequest } from 'src/api/updateRole';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { IRole } from 'src/types';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useUpdateRole = (onMutationSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { trackEvent, captureException } = useUserTracking();
  const queryClient = useQueryClient();

  return useMutation((role: IUpdateRoleRequest) => updateRole(role), {
    onSuccess: (data: IRole) => {
      trackEvent('role_updated', {
        permission_count: data.permissions?.length || 0,
      });
      showSnackbar({
        status: SnackbarStatus.SUCCESS,
        message: (
          <>
            <strong>{data.name}</strong> has successfully been updated.
          </>
        ),
      });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ROLES] });
      onMutationSuccess();
    },
    onError: (error: Error, req) => {
      showSnackbar({
        status: SnackbarStatus.ERROR,
        message: (
          <>
            Unable to update <strong>{req.name}</strong>
          </>
        ),
      });

      captureException(error);
    },
  });
};
